import React from "react";
import { Skeleton } from "@material-ui/lab";
import { Grid, Paper } from "@material-ui/core";

function FormSkeleton({
  rowsNum = 6,
  maxWidth = "initial",
  width = "100%",
  ...restProps
}) {
  return (
    <Paper style={{ padding: 24, maxWidth, width }} {...restProps}>
      <Grid container spacing={3}>
        {Array.from({ length: rowsNum }).map((_, index) => (
          <React.Fragment key={index}>
            <Grid item xs={12} sm={3}>
              <Skeleton variant="rect" width={"90%"} height={20} />
            </Grid>
            <Grid item xs={12} sm={9}>
              <Skeleton variant="rect" width={"60%"} height={44} />
            </Grid>
          </React.Fragment>
        ))}
      </Grid>
    </Paper>
  );
}

export default FormSkeleton;
